import { render, staticRenderFns } from "./Error50x.vue?vue&type=template&id=0580cfba&scoped=true"
import script from "./Error50x.vue?vue&type=script&lang=js"
export * from "./Error50x.vue?vue&type=script&lang=js"
import style0 from "./Error50x.vue?vue&type=style&index=0&id=0580cfba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0580cfba",
  null
  
)

export default component.exports